import { render, staticRenderFns } from "./BrandInfoModal.vue?vue&type=template&id=2e9024a5&scoped=true&"
import script from "./BrandInfoModal.vue?vue&type=script&lang=js&"
export * from "./BrandInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandInfoModal.vue?vue&type=style&index=0&id=2e9024a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9024a5",
  null
  
)

export default component.exports